// extracted by mini-css-extract-plugin
module.exports = {"emptyState":"EmptyState_emptyState__3GBDO","nonIdealDesc":"EmptyState_nonIdealDesc__14ObL","create":"EmptyState_create__3EHfc","learnMore":"EmptyState_learnMore__EFrhH"};